import React from 'react';

class Card extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    let listing = this.props.listing;
    let formatted = listing.description
      .replace(/\r/g, '')      //get rid of carriage returns
      .split(/\n/g)            //break string into array at newlines
      .filter(n => n)          //filter out empty "paragraphs"
      .map((paragraph, i, ctx) => { //wrap each in `p` tag
        if (i === ctx.length - 1) {
          return <p key={ i }>{ paragraph } <a href={ listing.link }>More »</a></p>
        } else {
          return <p key={ i }>{ paragraph }</p>
        }
      });


    return (
      <div className="jobs-listings-card" id={ listing.id }>
        <div className="jobs-card-headline">
          <h3>
            <a href={ listing.link }>{ listing.title }</a>
          </h3>
        </div>
        <div className="jobs-card-meta">
          <div className="jobs-card-description">
            { formatted }
          </div>
        </div>
      </div>
    );
  }
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/Jobs/Listings/Card.js